import { useState } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { AddIcon, ArrowBackIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { SchemaSavePayload } from '@atom/types/schema';

import CreateEditSchemaModal from '../common/createEditSchemaModal/CreateEditSchemaModal';

import classes from './schemaPortal.module.css';

interface Props {
  addSchema: (payload: SchemaSavePayload) => void;
}

const styles = {
  icon: {
    width: '24px',
    height: '24px',
    fontWeight: '500',
  },
  button: {
    padding: '0 1rem',
  },
};

const SchemaPortalHeader = ({ addSchema }: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [, { navigate }] = useNavigation();

  const handleSave = (payload: SchemaSavePayload) => {
    addSchema(payload);
    setOpen(false);
  };

  const navigateBack = () => {
    navigate('/inventory');
  };

  return (
    <>
      <div className={classes.navigationBarContainer}>
        <div className={classes.backNavigationContainer} onClick={navigateBack}>
          <div className={classes.backButtonIcon}>
            <Icon
              color={colors.neutral.white}
              style={styles.icon}
              icon={ArrowBackIcon}
            />
          </div>
          <div className={classes.backButtonText}>Inventory Types</div>
        </div>
        <IconButton onClick={() => setOpen(true)} tooltip="Add Inventory Type">
          <Icon color={colors.neutral.white} icon={AddIcon} />
        </IconButton>
      </div>
      <CreateEditSchemaModal
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
      />
    </>
  );
};

export default SchemaPortalHeader;
